import React, { createContext, useContext, useState } from 'react';

const ScreenLockContext = createContext();

export const useScreenLock = () => {
  const context = useContext(ScreenLockContext);
  if (!context) {
    throw new Error('useScreenLock must be used within a ScreenLockProvider');
  }
  return context;
};

export const ScreenLockProvider = ({ children }) => {
  const [isLocked, setIsLocked] = useState(false);
  const [lockTime, setLockTime] = useState(null);

  const lockScreen = () => {
    setIsLocked(true);
    setLockTime(new Date());
  };

  const unlockScreen = () => {
    setIsLocked(false);
    setLockTime(null);
  };

  const value = {
    isLocked,
    lockTime,
    lockScreen,
    unlockScreen,
  };

  return <ScreenLockContext.Provider value={value}>{children}</ScreenLockContext.Provider>;
};
